import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, PreloadActionModalSchema, Transitions } from "../../types"
import { preloadModalState } from "../manageModals/preloadModalState"

export const assignStudentsModalState: StateNodeConfig<
  Context,
  PreloadActionModalSchema,
  Transitions,
  BaseActionObject
> = {
  entry: [
    assign<Context>({ openAssignStudentsModal: true }),
    "resetClassStudents"
  ],
  exit: [
    assign<Context>({
      openAssignStudentsModal: false,
      selectedClassRecord: null
    }),
    "resetClassStudents"
  ],
  ...preloadModalState(
    "#ManageUserModules.classes_page.loading",
    "assignStudents",
    {
      preload: {
        serviceCall: "fetchClassStudents",
        successActions: [
          assign((_ctx, evt) => ({
            students: evt.data.students,
            assignedStudents: evt.data.assignedStudents
          }))
        ],
        errorActions: [
          assign((_ctx, evt) => ({
            snackbar: {
              message: `An error occurred. Unable to load students data: ${evt.data.message}`,
              withUndo: false,
              error: true
            }
          }))
        ]
      },
      cancelTarget: "#ManageUserModules.classes_page.idle",
      loadingState: "assignStudents",
      onSuccess: (ctx, _evt) => ({
        snackbar: {
          message:
            ctx.assignAction === "no-change"
              ? `There were no changes made to ${ctx.snackbarMessageInfo}`
              : `Successfully ${ctx.assignAction} students to ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: false
        }
      }),
      onError: (ctx, _evt) => ({
        snackbar: {
          message: `An error occurred. Unable to assign students to ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: true
        }
      })
    }
  )
}
